module.exports = __webpack_public_path__ + "img/Asset116.5c4d3593.png";